module.exports = __webpack_public_path__ + "static/img-error-70602f547e7c7a02068a716b35036ec7.svg";